module.exports = __webpack_public_path__ + "static/img/logoColor.d5f9aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg/logoColor.png
// module id = 9zkV
// module chunks = 10